// extracted by mini-css-extract-plugin
module.exports = {"input":"stringInput__input___1nuFd"};